<h1>IACKATHON</h1>
<a [routerLink]="['/iackathon-groups']"> Suivre vos élèves</a>
<h2>Un atelier en quatre phases</h2>
<p>Choisir une problématique, trouver une idée, réaliser un livrable et le présenter à ses camarades.</p>
<h2>Initiation à l’usage de l’IA</h2>
<p>Vos élèves seront guidés dans une utilisation responsable et raisonnée de l’IA générative.</p>
<h2>Démarche Design Thinking</h2>
<p>Une démarche structurée pour résoudre des problèmes réels en imaginant des solutions concrètes.</p>
<h2>Des compétences clés</h2>
<p>Un travail de groupe pour stimuler la créativité, la collaboration et la communication.</p>
<a href="">
    Lire la fiche pédagogique - TODO QUELLE FICHE PÉDAGOGIQUE MARION ?
</a>
<a href="">
    Voir la vidéo - TODO QUELLE VIDÉO MARION ?
</a>
<a [routerLink]="['/iackathon']">Essayer</a>